import { useQuery } from "@tanstack/react-query";
import { apiRequestRaw } from "../../../shared/api/http";
import { HttpError } from "../../../shared/api/http";
import type { AccountCardResponse } from "../../../shared/types/account-card.type";
import {
	isValidAccountCardId,
	normalizeAccountCardId,
} from "../../../shared/utils/normalize-account-card-id";
import { AccountCardFetchError } from "../errors/account-card-fetch-error";

async function fetchAccountCard(accountId: string): Promise<AccountCardResponse> {
	try {
		return await apiRequestRaw<AccountCardResponse>({
			path: "/api/ui/account/card",
			method: "POST",
			json: {
				account_id: accountId,
			},
		});
	} catch (e) {
		if (e instanceof HttpError) {
			throw new AccountCardFetchError("fetch-failed", e.status);
		}
		throw e;
	}
}

export const accountCardQueryKey = (accountId: string) =>
	["account-card", normalizeAccountCardId(accountId)] as const;

export function useAccountCard(accountId: string | undefined) {
	const normalizedId =
		accountId && isValidAccountCardId(accountId)
			? normalizeAccountCardId(accountId)
			: undefined;

	return useQuery({
		queryKey: accountCardQueryKey(normalizedId ?? ""),
		queryFn: () => fetchAccountCard(normalizedId!),
		enabled: Boolean(normalizedId),
		staleTime: 60_000,
		retry: false,
	});
}
